import ClientDetailInfo from "./ClientDetailInfo";
import ClientDetailSummary from "./ClientDetailSummary";
import ClientDetailGraph from "./ClientDetailGraph";
import {useState} from "react";
import {StackLayout, TileLayout} from "@progress/kendo-react-layout";
import useClientStore from "../../stores/ClientStore";
import useFetch from "../../tools/UseFetch";
import config from "../../config/config.json";

const ClientDetail = props => {


    const {selectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient}))

    const { data:summaryData, isPending:summaryData_IsPending, error:summaryData_error} = useFetch(config.API_URL + 'tms/summary/' + selectedClient.ID, 0)
    const { data:chartData, isPending, error} = useFetch(config.API_URL + 'tms/graph/' + selectedClient.ID, 0)
    const { data:projects, isPending:projects_IsPending, error:projects_error} = useFetch(config.API_URL + 'project/forClient/' + selectedClient.ID, 0)

    // const tiles = [
    //     {
    //         header: "Detail klienta",
    //         body: <ClientDetailInfo cliet={selectedClient} />,
    //         resizable: false,
    //         reorderable: false,
    //     },
    //
    //     {
    //         header: "Přehled",
    //         body: <>{summaryData && <ClientDetailSummary data={summaryData}/>}</>,
    //         resizable: false,
    //         reorderable: false,
    //     },
    //     {
    //         header: "graf",
    //         body: <>{chartData && <ClientDetailGraph data={chartData} projects={projects}/>}</>,
    //         resizable: false,
    //         reorderable: false,
    //     },
    //
    // ];
    //
    // const [data, setData] = useState([
    //     {
    //         col: 1,
    //         colSpan: 10,
    //         rowSpan: 10,
    //     },
    //     {
    //         col: 1,
    //         colSpan: 10,
    //         rowSpan: 10,
    //     },
    //     {
    //         col: 1,
    //         colSpan: 10,
    //         rowSpan: 10,
    //     },
    //
    // ]);
    // const handleReposition = (e) => {
    //     setData(e.value);
    //     console.log(e.value);
    // };

    return(
        <>

            <div className="client-detail">

                <StackLayout orientation={"vertical"}>
                    <ClientDetailInfo cliet={selectedClient} />
                    <>{summaryData && <ClientDetailSummary data={summaryData}/>}</>
                    <>{chartData && <ClientDetailGraph data={chartData} projects={projects}/>}</>
                </StackLayout>

            </div>

        </>
    )
}

export default ClientDetail